import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import InviteUsersContent from '../../components/Pages/InviteUsers';
import InviteUsersProvider from '../../context/inviteUsersContext';

const { displayName } = config;

export default function InviteUsers(): React.ReactNode | null {
  document.title = `${displayName}: Invite Users`;

  return (
    <Layout
      title="Inivite users"
    >
      <InviteUsersProvider>
        <InviteUsersContent />
      </InviteUsersProvider>
    </Layout>
  );
}
